/**
 * AOS
 */
declare var AOS: any;

const aos = () => {
  AOS.init();
};

export default aos;
